/**
 * Returns true if the supplied UserStatus-shaped data
 * can be displayed as a percent, meaning it either _is_
 * based directly on percent or has a page number out of a
 * known total number of pages. Some books don't have a numPages
 * attribute.
 *
 * This is duplicative of reading_session_helper#isDisplayableAsPercent.
 *
 * @param userStatus
 * @returns {boolean}
 */
export function isDisplayableAsPercent(userStatus) {
  return !!userStatus.maxProgressValue;
}
